'use client';

import { createContext, useContext, type ReactNode } from 'react';

interface ProjectPageContextValue {
  onDeleteProject: () => void;
  isArchived: boolean;
}

const ProjectPageContext = createContext<ProjectPageContextValue | null>(null);

export function ProjectPageProvider({
  children,
  value,
}: {
  children: ReactNode;
  value: ProjectPageContextValue;
}) {
  return (
    <ProjectPageContext.Provider value={value}>
      {children}
    </ProjectPageContext.Provider>
  );
}

export function useProjectPageContext() {
  const context = useContext(ProjectPageContext);
  if (!context) {
    throw new Error(
      'useProjectPageContext must be used within ProjectPageProvider'
    );
  }
  return context;
}

export function useOptionalProjectPageContext() {
  return useContext(ProjectPageContext);
}
